import { render } from "./SaleDetailsView.vue?vue&type=template&id=61dc4732&scoped=true"
import script from "./SaleDetailsView.vue?vue&type=script&lang=js"
export * from "./SaleDetailsView.vue?vue&type=script&lang=js"

import "./SaleDetailsView.vue?vue&type=style&index=0&id=61dc4732&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61dc4732"]])

export default __exports__